import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-issues-grid',
  templateUrl: './issues-grid.component.html',
  styleUrls: ['./issues-grid.component.css']
})
  export class IssuesGridComponent implements OnInit {
    
  ticketList;
  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.GetAllTickets();
  }
  GetAllTickets() {
    // debugger;
    // this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllInternalTickets()
      .subscribe(
        (data:any) => {
          this.ticketList = data;
          // this.totalItems=data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/issues/issues-grid/issues-grid.component.ts